import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveSmallLeaderboardTopThreeDrop } from "./WaveSmallLeaderboardTopThreeDrop";
import { WaveSmallLeaderboardDefaultDrop } from "./WaveSmallLeaderboardDefaultDrop";
import { ApiWave } from "@/generated/models/ApiWave";
interface DefaultWaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const DefaultWaveSmallLeaderboardDrop: React.FC<DefaultWaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(10);
  const {
    drop,
    wave,
    onDropClick
  } = t0;
  let t1;
  if ($[0] !== drop || $[1] !== onDropClick) {
    t1 = () => onDropClick(drop);
    $[0] = drop;
    $[1] = onDropClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== drop || $[4] !== onDropClick || $[5] !== wave) {
    t2 = drop.rank && drop.rank <= 3 ? <WaveSmallLeaderboardTopThreeDrop drop={drop} wave={wave} onDropClick={onDropClick} /> : <WaveSmallLeaderboardDefaultDrop drop={drop} wave={wave} onDropClick={onDropClick} />;
    $[3] = drop;
    $[4] = onDropClick;
    $[5] = wave;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="tw-cursor-pointer" onClick={t1}>{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};